import React from 'react';
import useIsRtl from 'src/hooks/useIsRtl';
const RtlContainer = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const isRtl = useIsRtl();
  return <div dir={isRtl ? 'rtl' : 'ltr'} {...props} data-sentry-component="RtlContainer" data-sentry-source-file="index.tsx" />;
};
export default RtlContainer;